import React, { useEffect, useState } from "react";
import "./HighlightDataSection.css";
import { Button } from "antd";
import { BannerSkeleton } from "../../BannerSkeleton";
import {
  addHttpToLink,
  isNavigable,
  lightenColor,
} from "../../../../Utils/StayUpToDate/RenderComponent";
import { convertToWebP, preserveBrokenImageBox } from "../../../../Utils/imageUtils";
import { isHexDark } from "../../../../Utils/HelperFunction/HelperFunction";
import { darkenColor } from "../../../../Screens/DashboardView/StayUpToDate/LandingPageComponents/LinksComponent/Components/hoverUtils";
import {
  hasHighlightCropDimensions,
  parseHighlightImageDetails,
} from "../../../../Utils/imageCrop/highlightImageDetails";
import {
  hasWebsiteLibBannerQuery,
  parseWebsiteLibBannerOptions,
} from "../../../../Screens/DashboardView/MasterTemplateEditor/websiteLibBannerOptions";
import { isLikelyVideoUrl } from "../../../../Utils/media/feedMedia";
import {
  bannerImageFrameStyle,
  normalizeBannerImageFrame,
} from "../../../../Screens/DashboardView/MasterTemplateEditor/templateBannerUtils";
const HighlightDataSection = (props: any) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 400);
  }, []);
  const {
    data,
    handleRedirect,
    brand_color,
    from,
    designTokens,
    isMobileView=false,
  } = props;
  const templateName = designTokens?.templateName;
  const effectiveTemplateName = (templateName || "").toLowerCase();
  const isDefaultTheme = effectiveTemplateName === "default";
  const buttonBg = isDefaultTheme
    ? (designTokens?.secondaryColor || "#000")
    : (designTokens?.forthColor|| "#000");
  const buttonOverrideClass = isDefaultTheme ? "highlight-btn-override" : "";
  const highlightDetails = parseHighlightImageDetails(data?.details);
  const highlightImageUrl = highlightDetails.imageUrl;
  const highlightLinkUrl = highlightDetails.linkUrl;
  const useCoverFrame = hasWebsiteLibBannerQuery(data?.query);
  const coverOpts = parseWebsiteLibBannerOptions(data?.query);
  const coverFrameStyle = useCoverFrame
    ? bannerImageFrameStyle(
        normalizeBannerImageFrame({
          imageZoom: coverOpts.imageZoom,
          imageX: coverOpts.imageX,
          imageY: coverOpts.imageY,
        }),
      )
    : undefined;
  const useSquareCropClass =
    !useCoverFrame && hasHighlightCropDimensions(data || {});
  // Presentation (left/right) is side-by-side only above 600px; CSS stacks on narrow.
  const applyPresentation = highlightDetails.view === "right";

  return (
    <>
      {isDefaultTheme && (
        <style>{`
          .uptodate-wrapper .highlight-btn-override,
          .uptodate-wrapper .highlight-btn-override:hover,
          .uptodate-wrapper .highlight-btn-override:focus,
          .uptodate-wrapper .highlight-btn-override:active {
            color: #fff !important;
          }
          .uptodate-wrapper .highlight-btn-override span { color: #fff !important; }
        `}</style>
      )}
      {loading ? (
        <BannerSkeleton designTokens={designTokens} />
      ) : (
        <>
          <div
            className="outter-section highlight-section"
            style={{
              backgroundColor: designTokens?.primaryColor || brand_color,
              // Same as LatestPodcastData — theme.muted on the outer card.
              // Hardcoded #e6e7eb reads as no border on tinted LiB palettes.
              borderColor: designTokens?.tertiaryColor,
            }}
          >
            <a
              href={
                highlightLinkUrl?.startsWith("http")
                  ? highlightLinkUrl
                  : `http://${highlightLinkUrl}`
              }
              className="highlight-link-tag"
              style={{
                backgroundColor: designTokens?.primaryColor,
              }}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // if (data.details.split(",")[2] === "link") {
                //   handleShop(
                //     data.id,
                //     data.details.split(",")[0],
                //     data?.name,
                //     data?.name
                //   );
                // } else {
                handleRedirect(
                  data.id,
                  highlightImageUrl,
                  "",
                  data?.name,
                  data?.name,
                  "",
                  from
                );
                // }

                const url = highlightLinkUrl;
                if (url && url !== "") {
                  // const validUrl = url.startsWith("http")
                  //   ? url
                  //   : `http://${url}`;

                  window.open(addHttpToLink(url), "_blank");
                }
              }}
            >
              <div
                className={`highlight-data-section ${isMobileView ? "highlight-data-section-mobile" : ""} ${ isMobileView ? "highlights-view-mobile" : ""}${applyPresentation ? " highlight-presentation-right" : ""}`}
                style={{
                  ...(data && data.details && data.details.split(",")[0]
                    ? applyPresentation
                      ? {
                          flexDirection: "row-reverse",
                          backgroundColor: designTokens?.primaryColor,
                        }
                      : {
                          backgroundColor: designTokens?.primaryColor,
                        }
                    : {
                        minHeight: "250px",
                        display: "flex",
                        backgroundColor: designTokens?.primaryColor,
                      }),
                  // Outer `.outter-section` carries the themed border (like podcast).
                  border: designTokens?.tertiaryColor
                    ? "none"
                    : "1px solid #e6e7eb",
                }}
              >
                {data && data.details && data.details.split(",")[0] && (
                  <div
                    className={`highlight-media ${applyPresentation ? "highlight-media-right" : "highlight-media-left"} ${isMobileView ? "highlight-media-mobile" : ""}${useCoverFrame ? " highlight-media--cover-frame" : ""}`}
                  >
                    {data && data.details ? (
                      <>
                        {isLikelyVideoUrl(highlightImageUrl) ? (
                          <video
                            controls
                            className="highlight-video"
                            preload="none"
                            playsInline
                          >
                            <source
                              src={highlightImageUrl}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img
                            src={convertToWebP(highlightImageUrl)}
                            alt="Media"
                            className={`highlight-image${
                              useSquareCropClass ? " highlight-square-image" : ""
                            }`}
                            style={coverFrameStyle}
                            loading="lazy"
                            decoding="async"
                            onError={preserveBrokenImageBox}
                          />
                        )}
                      </>
                    ) : (
                      <span>No media available</span>
                    )}
                  </div>
                )}
                <div
                  className={`highlight-details ${isMobileView ? "highlight-details-mobile" : ""}`}
                  style={
                    highlightImageUrl
                      ? {}
                      : { width: "80%" }
                  }
                >
                  <div
                    className={`highlight-name ${isMobileView ? "highlight-name-mobile" :""}`}
                    style={{
                      cursor: isNavigable(data) ? "pointer" : "default",
                      fontFamily: designTokens?.primaryFontFamily
                    }}
                  >
                    {data.name}{" "}
                  </div>
                  {data?.cta_placeholder && (
                    <div className="text-center">
                      <Button
                        className={`highlight-shop-button ${designTokens?.secondaryColor ? "custom-button-with-hover" : ""} ${buttonOverrideClass} ${isMobileView ? "highlight-shop-button-mobile" : ""}`}
                        style={{
                          ...(isDefaultTheme && {
                            backgroundColor: buttonBg,
                            color: designTokens?.primaryColor}),
                          fontFamily: designTokens?.secondaryFontFamily,
                          ...(designTokens?.fontFamily
                            ? ({
                                ["--highlight-font" as any]:
                                  designTokens?.secondaryFontFamily,
                              } as any)
                            : {}),
                          ...(buttonBg
                            ? ({
                                ["--hover-bg" as any]: isHexDark(buttonBg) ? lightenColor(buttonBg, 20) : darkenColor(buttonBg, 10),
                              } as any)
                            : {})
                        }}
                      >
                        {data?.cta_placeholder}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </a>
          </div>
        </>
      )}
    </>
  );
};

export default HighlightDataSection;
